import React from "react";
import { TextField } from "@mui/material";

const BaseTextField = (props) => {
  return (
    <TextField fullWidth label="Title" type="text" size="small" {...props} />
  );
};

export default BaseTextField;
